package com.devi3east.bashbuddy.favorites.ui

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import app.cash.sqldelight.db.QueryResult.Companion.Unit
import com.devi3east.bashbuddy.favorites.ui.components.EmptyFavoriteContent
import com.devi3east.bashbuddy.favorites.ui.components.FavoriteEventCard
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.events.common.data.models.Event
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun FavoriteEventsRoute(
    appState: AppState,
    navigateToEventDetail: (String, String) -> Unit
) {
    val viewModel: FavoriteEventsViewModel = koinViewModel()

    LaunchedEffect(Unit) {
        val t = appState.authViewModel.uiState.value.token
        if (!t.isNullOrBlank()) {
            viewModel.loadFavoriteEvents()
        }
    }

    val uiState by viewModel.uiState.collectAsState()

    FavoriteEventsScreen(
        appState = appState,
        uiState = uiState,
        navigateToEventDetail = navigateToEventDetail,
        onRemoveFavorite = { eventId -> viewModel.removeFavorite(eventId) },
        onBrowseEvents = { appState.navController.navigate(Screen.EventsScreen.route) },
    )
}

@Composable
fun FavoriteEventsScreen(
    appState: AppState,
    uiState: FavoriteEventsUiState,
    navigateToEventDetail: (String, String) -> Unit,
    onRemoveFavorite: (String) -> Unit,
    onBrowseEvents: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
    ) {
        when {
            uiState.isLoading -> {
                Box(Modifier.fillMaxSize(), Alignment.Center) {
                    CircularProgressIndicator()
                }
            }

            uiState.errorMessage != null -> {
                Box(Modifier.fillMaxSize(), Alignment.Center) {
                    Text(
                        text = uiState.errorMessage,
                        color = MaterialTheme.colorScheme.error
                    )
                }
            }

            uiState.eventsList.isEmpty() -> {
                EmptyFavoriteContent(onBrowseEvents)
            }

            else -> {
                BoxWithConstraints(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(horizontal = 16.dp, vertical = 8.dp)
                ) {
                    val maxWidthDp = maxWidth
                    val targetWidth = when {
                        maxWidthDp < 600.dp -> maxWidthDp
                        maxWidthDp < 900.dp -> 600.dp
                        else -> 720.dp
                    }
                    LazyColumn(
                        modifier = Modifier
                            .widthIn(max = targetWidth)
                            .align(Alignment.TopCenter)
                    ) {
                        items(uiState.eventsList) { event: Event ->
                            FavoriteEventCard(
                                event = event,
                                navigateToEventDetail = { eventId, slug ->
                                    navigateToEventDetail(eventId, slug)
                                },
                                onRemoveFavorite = { eventId ->
                                    onRemoveFavorite(eventId)
                                }
                            )
                            Spacer(Modifier.height(8.dp))
                        }
                    }
                }
            }
        }
    }
}